module.exports = {
    localStorageNamed: 'Timbra1',
    general: {},
};